import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './index.css';
import App from './App';
// SW is registered automatically by vite-plugin-pwa (registerType: 'autoUpdate')
// serviceWorkerRegistration.js kept for unregister() utility during upgrades
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Sentry is prod-only — lazy-load to keep initial bundle lean
if (import.meta.env.PROD) {
  import('./lib/sentry').then(({ initSentry }) => initSentry());
}

// PostHog deferred to requestIdleCallback — keeps 61kB gz out of critical path.
// Events captured before init are queued in lib/posthog.js and flushed after init.
function deferPostHog() {
  import('./lib/posthog').then(({ initPostHog }) => initPostHog());
}
if (typeof requestIdleCallback !== 'undefined') {
  requestIdleCallback(deferPostHog);
} else {
  setTimeout(deferPostHog, 1000);
}

// V5 deploy hygiene : cleanup SW anciens + caches Workbox d'une version précédente
// avant de monter React. Évite chunks lazy expirés qui crashent React.lazy.
async function cleanupStaleServiceWorkers() {
  if (!('serviceWorker' in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.filter((k) => /workbox|melodiza/i.test(k)).map((k) => caches.delete(k)));
    }
  } catch (err) {
    console.warn('[boot] SW cleanup failed', err);
  }
}

cleanupStaleServiceWorkers().finally(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );

  reportWebVitals();
  // Re-register le SW avec la nouvelle version (Workbox CRA standard).
  serviceWorkerRegistration.register();
});
